import { combineReducers } from 'redux';
import user from './user';
import form from './form';
import loading from './loading';
import metadata from './metadata';
import unread from './unread';
export default combineReducers({ user, form, loading, metadata, unread });
